(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs-slider')) {
    class CollectionTabsSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.tabs = Array.from(
          this.querySelectorAll('[data-ctps-tab]')
        );

        this.panels = Array.from(
          this.querySelectorAll('[data-ctps-panel]')
        );

        this.handleTabClick =
          this.handleTabClick.bind(this);

        this.handleTabKeyboard =
          this.handleTabKeyboard.bind(this);

        this.handleArrow =
          this.handleArrow.bind(this);

        this.handleScroll =
          this.handleScroll.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener(
            'click',
            this.handleTabClick
          );

          tab.addEventListener(
            'keydown',
            this.handleTabKeyboard
          );
        });

        this.querySelectorAll('[data-ctps-arrow]')
          .forEach((button) => {
            button.addEventListener(
              'click',
              this.handleArrow
            );
          });

        this.querySelectorAll('[data-ctps-track]')
          .forEach((track) => {
            track.addEventListener(
              'scroll',
              this.handleScroll,
              { passive: true }
            );
          });

        if ('ResizeObserver' in window) {
          this.resizeObserver =
            new ResizeObserver(() => {
              this.update();
            });

          this.resizeObserver.observe(this);
        } else {
          this.handleResize = () => this.update();

          window.addEventListener(
            'resize',
            this.handleResize
          );
        }

        requestAnimationFrame(() => {
          this.update();
        });
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => {
          tab.removeEventListener(
            'click',
            this.handleTabClick
          );

          tab.removeEventListener(
            'keydown',
            this.handleTabKeyboard
          );
        });

        this.querySelectorAll('[data-ctps-arrow]')
          .forEach((button) => {
            button.removeEventListener(
              'click',
              this.handleArrow
            );
          });

        this.querySelectorAll('[data-ctps-track]')
          .forEach((track) => {
            track.removeEventListener(
              'scroll',
              this.handleScroll
            );
          });

        this.resizeObserver?.disconnect();

        if (this.handleResize) {
          window.removeEventListener(
            'resize',
            this.handleResize
          );
        }
      }

      getVisibleCards() {
        const width = window.innerWidth;

        if (width <= 749) {
          return 2;
        }

        if (width <= 989) {
          return 3;
        }

        return 4;
      }

      getActivePanel() {
        return this.panels.find(
          (panel) => !panel.hidden
        );
      }

      handleTabClick(event) {
        this.activateTab(event.currentTarget);
      }

      handleTabKeyboard(event) {
        const index =
          this.tabs.indexOf(event.currentTarget);

        if (index === -1) return;

        let newIndex = null;

        switch (event.key) {
          case 'ArrowRight':
            newIndex =
              (index + 1) % this.tabs.length;
            break;

          case 'ArrowLeft':
            newIndex =
              (index - 1 + this.tabs.length) %
              this.tabs.length;
            break;

          case 'Home':
            newIndex = 0;
            break;

          case 'End':
            newIndex =
              this.tabs.length - 1;
            break;
        }

        if (newIndex === null) return;

        event.preventDefault();

        const nextTab = this.tabs[newIndex];

        nextTab.focus();

        this.activateTab(nextTab);
      }

      activateTab(tab) {
        const panelId =
          tab.dataset.panel;

        if (!panelId) return;

        const panel =
          this.querySelector(
            `#${CSS.escape(panelId)}`
          );

        if (!panel) return;

        this.tabs.forEach((current) => {
          const active =
            current === tab;

          current.classList.toggle(
            'is-active',
            active
          );

          current.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

          current.tabIndex =
            active ? 0 : -1;
        });

        this.panels.forEach(
          (currentPanel) => {
            currentPanel.hidden =
              currentPanel !== panel;
          }
        );

        const track =
          panel.querySelector(
            '[data-ctps-track]'
          );

        if (track) {
          track.scrollLeft = 0;
        }

        tab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });

        requestAnimationFrame(() => {
          this.updatePanel(panel);
        });
      }

      handleArrow(event) {
        const button =
          event.currentTarget;

        const panel =
          button.closest(
            '[data-ctps-panel]'
          );

        const track =
          panel?.querySelector(
            '[data-ctps-track]'
          );

        const firstSlide =
          track?.querySelector(
            '[data-ctps-slide]'
          );

        if (!track || !firstSlide) {
          return;
        }

        const styles =
          window.getComputedStyle(track);

        const gap =
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            0
          ) || 0;

        const width =
          firstSlide.getBoundingClientRect().width;

        const direction =
          button.dataset.ctpsArrow === 'prev'
            ? -1
            : 1;

        track.scrollBy({
          left:
            (width + gap) *
            direction,
          behavior: 'smooth'
        });
      }

      handleScroll(event) {
        const panel =
          event.currentTarget.closest(
            '[data-ctps-panel]'
          );

        if (!panel) return;

        requestAnimationFrame(() => {
          this.updatePanel(panel);
        });
      }

      update() {
        this.panels.forEach((panel) => {
          this.updatePanel(panel);
        });
      }

      updatePanel(panel) {
        const track =
          panel.querySelector(
            '[data-ctps-track]'
          );

        if (!track) return;

        const prev =
          panel.querySelector(
            '[data-ctps-arrow="prev"]'
          );

        const next =
          panel.querySelector(
            '[data-ctps-arrow="next"]'
          );

        const productCount =
          Number(
            panel.dataset.productCount || 0
          );

        const visibleCards =
          this.getVisibleCards();

        const needsSlider =
          productCount > visibleCards;

        const isMobile =
          window.innerWidth <= 749;

        const showArrows =
          isMobile
            ? this.dataset.mobileArrows === 'true'
            : this.dataset.desktopArrows === 'true';

        if (prev) {
          prev.hidden =
            !needsSlider ||
            !showArrows;
        }

        if (next) {
          next.hidden =
            !needsSlider ||
            !showArrows;
        }

        if (!needsSlider) {
          if (prev) {
            prev.disabled = true;
          }

          if (next) {
            next.disabled = true;
          }

          return;
        }

        const maxScroll =
          track.scrollWidth -
          track.clientWidth;

        const tolerance = 3;

        if (prev) {
          prev.disabled =
            track.scrollLeft <=
            tolerance;
        }

        if (next) {
          next.disabled =
            track.scrollLeft >=
            maxScroll - tolerance;
        }
      }
    }

    customElements.define(
      'collection-tabs-slider',
      CollectionTabsSlider
    );
  }

  } catch(e) { console.error(e); }
})();
})();
